import axios from "../../public Func/axiosAuth";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/chat`;

export interface ChatroomData {
  id: string;
  patient: { id: string; name: string; profile_img?: string };
  adminId: number | null;
  chatType: string;
  lastMessage: string | null;
  lastSender: string | null;
  lastUpdate: string | null;
  unseenCount: number;
  quota: number;
  createdAt: string;
}

export interface MessageData {
  id: string;
  text: string;
  senderRole: "patient" | "admin";
  seen: boolean;
  deleted: boolean;
  attachment: string | null;
  createdAt: string;
}

export async function getAdminChatrooms(
  userId: string,
): Promise<ChatroomData[]> {
  const res = await axios.get(`${BASE}/chatrooms`, {
    params: { userID: userId, role: "admin", filter: "assigned" },
  });
  return Array.isArray(res.data) ? res.data : res.data?.data || [];
}

export async function getPendingAdminChatrooms(
  userId: string,
): Promise<ChatroomData[]> {
  const res = await axios.get(`${BASE}/chatrooms`, {
    params: { userID: userId, role: "admin", filter: "pending" },
  });
  return Array.isArray(res.data) ? res.data : res.data?.data || [];
}

export async function assignFadfaddahRoom(chatroomID: string | number): Promise<ChatroomData> {
  const res = await axios.post(`${BASE}/fadfaddah/assign`, { chatroomID });
  return res.data?.data || res.data;
}

export async function getChatroomMessages(
  chatroomId: string,
): Promise<MessageData[]> {
  const res = await axios.get(`${BASE}/messages`, {
    params: { chatroomID: chatroomId, role: "admin" },
  });
  return Array.isArray(res.data) ? res.data : res.data?.data || [];
}

export async function sendChatroomMessage(
  chatroomId: string,
  text: string,
): Promise<MessageData> {
  const res = await axios.post(`${BASE}/message`, {
    chatroomID: chatroomId,
    senderRole: "admin",
    text,
  });
  return res.data?.data || res.data;
}

export async function markChatroomSeen(chatroomId: string): Promise<void> {
  await axios.post(`${BASE}/mark-seen`, {
    chatroomID: chatroomId,
    role: "admin",
  });
}
